module.exports = __webpack_public_path__ + "img/bild-m.de04d7ff.png";